import { HUMAN_LEGIBLE_DEFAULT_HELP_HOTLINE } from 'src/common/constants';
import { PhoneLink } from 'src/components/Typography/PhoneLink';
import { getPhoneNumber } from 'src/components/Typography/PhoneLink/utils/getPhoneNumber';
import { LoanOfficerFragment } from 'src/services/graphql/generated/graphql';

export const LoanOfficerSubHeading = ({ loanOfficer }: { loanOfficer: LoanOfficerFragment }) => (
    <p>
        Please reach out to your loan officer {loanOfficer.name?.first ?? ' '} {loanOfficer.name?.last ?? ' '} at{' '}
        <PhoneLink {...getPhoneNumber(loanOfficer?.officePhone ?? HUMAN_LEGIBLE_DEFAULT_HELP_HOTLINE)} /> for
        assistance.
    </p>
);
